import { render } from "./OapImmersiveParallax.vue?vue&type=template&id=3ccd10d3"
import script from "./OapImmersiveParallax.vue?vue&type=script&lang=js"
export * from "./OapImmersiveParallax.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__